<template class="p-1">
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-row>
        <b-col class="col-lg-6">
          <b-card>
            <template v-slot:header>
              <strong>mProve</strong> <small>Settings</small>
            </template>
            <div class="form-group ">
              <button class="btn btn-primary float-right" @click="saveAccountSetting()">
                <i class="fa fa-plus-square" title="Save"></i> <strong class="text-white">Save Account</strong>
              </button>
            </div>
            <div class="form-group">
              <label for="name">Dealership_Id</label>
              <b-form-input type="text" v-model="AccountSettings.dealership_id" name="Dealership_Id" readonly></b-form-input>
            </div>
            <div class="form-group">
              <label for="name">Account Number</label>
              <b-form-input type="text" v-model="AccountSettings.account_number" name="Account_Number" readonly></b-form-input>
            </div>
            <div class="form-group">
              <label for="name">StoneEagle Dealer Number</label>
              <b-form-input type="text" v-model="AccountSettings.se_account_number" name="SE_Account_Number" isenabled="AccountSettings.canedit"></b-form-input>
            </div>
            <div class="form-group">
              <label for="name">Custom Mappings</label>
              <div class="row mb-2">
                <div class="col-lg-4 pr-0"><b-form-select :options="CustomMappingTypes" v-model="ddCustomMappingType"></b-form-select></div>
                <div class="col-lg-2 pl-0">
                  <button class="btn btn-info text-white" style="display:inline" @click="addCustomMapping()">
                    <i class="fa fa-plus-square fa-lg" title="Add"></i>
                  </button>
                </div>
              </div>
              <div class="row" v-for="cm in AccountSettings.custom_mappings" v-bind:key="cm.Type">
                <div class="col-lg-4">MSIS: {{ cm.Type }}</div>
                <div class="col-lg-4">
                  <div class="row">
                    <div>
                      Map:
                    </div>
                    <div class="col p-0">
                      <b-form-input type="text" v-model="cm.Value"></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="row">
                    <div>
                      Tax:
                    </div>
                    <div class="col p-0">
                      <b-form-select :options="['None','InCap','UpFront']" v-model="cm.Tax"></b-form-select>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 pl-0">
                  <button class="btn btn-info text-white" style="display:inline" @click="delCustomMapping(cm.Type)">
                    <i class="fa fa-trash fa-lg" title="Delete"></i>
                  </button>
                </div>
              </div>

            </div>

            <div class="form-group">
              <label for="name">Main Contact</label>
              <b-form-input type="text" v-model="SubscriberMain.fullname" name="FullName" readonly></b-form-input>
            </div>

            <div class="form-group">
              <button class="btn btn-success" @click="addSubscriber()">
                <i class="fa fa-plus-square" title="Add subscriber"></i> <strong class="text-white">Add subscriber</strong>
              </button>
            </div>

            <b-table striped hover :items="Subscribers" :fields="myfields">
              <template v-slot:cell(created_ts)="data">
                {{  data.item.created_ts | formatShortDate }}
              </template>
              <template v-slot:cell(disabled)="data">
                <b-row style="padding-top:5px;">
                  <b-col md="12">
                    <input type="checkbox" v-model="data.item.disabled" disabled />
                  </b-col>
                </b-row>
              </template>
              <template v-slot:cell(ActionEdit)="data">
                <b-row style="padding-top:5px;">
                  <b-col md="12">
                    <button class="btn btn-primary text-white" @click="editSubscriber(data.item.subscriber_id)">
                      <i class="fa fa-edit" title="Edit"></i> <strong class="text-white">Edit</strong>
                    </button>
                  </b-col>
                </b-row>
              </template>
              <template v-slot:cell(ActionDelete)="data">
                <b-row style="padding-top:5px;">
                  <b-col md="12">
                    <button v-if="IsNotDisabled(data.item.disabled)" class="btn btn-danger text-black" @click="disableSubscriber(data.item.subscriber_id,true)">
                      <i class="fa fa-edit" title="Disable"></i> <strong class="text-white">Disable</strong>
                    </button>
                    <button v-if="IsDisabled(data.item.disabled)" class="btn btn-warning text-black" @click="disableSubscriber(data.item.subscriber_id,false)">
                      <i class="fa fa-edit" title="Enable"></i> <strong class="text-white">Enable</strong>
                    </button>
                  </b-col>
                </b-row>
              </template>

            </b-table>
          </b-card>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import moment from 'moment'
import store from '@/store'

export default {
  components: {
    loading
  },
  created () {
    this.fetchData()
  },
  data () {
    return {
      boolLoading: false,
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      txtLoading: 'Loading...',
      lastRefreshed: moment(),
      SubscriberMain: {
        fullname: ''
      },
      ddCustomMappingType: null,
      AccountSettings: {
        account_number: '',
        dealership_id: 0,
        se_account_number: '',
        custom_mappings: [],
        canedit: false
      },
      CustomMappingTypes: ['AcquisitionFee', 'RegistrationFee'],
      Subscribers: [],
      myfields: [
        { key: 'fullname', label: 'FullName', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'created_ts', label: 'Created_TS', sortable: false },
        { key: 'disabled', label: 'Disabled', sortable: true },
        { key: 'ActionEdit', label: '', sortable: false },
        { key: 'ActionDelete', label: '', sortable: false }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0

    }
  },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a')
      }
      return ''
    },
    formatShortDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY')
      }
      return ''
    },
    formatAccessDisplay: function (accessBool) {
      var display = 'No'
      if (accessBool) {
        display = 'Yes'
      }
      return display
    }
  },
  methods: {
    getRowCount () {
      return this.FilteredRecords.length
    },
    fetchData () {
      axios.get('/api/mprove/GetSettings_Subcribers_Main_All')
        .then(response => {
          this.boolLoading = false

          if (response.data.Main_Subscriber.length > 0) {
            this.SubscriberMain = response.data.Main_Subscriber[0]
          }
          if (response.data.Subscribers.length > 0) {
            this.Subscribers = response.data.Subscribers
          }
          if (response.data.AccountSettings.length > 0) {
            this.AccountSettings = response.data.AccountSettings[0]
            this.AccountSettings.canedit = store.state.isInternalStaff
            if (response.data.AccountSettings[0].custom_mappings == null) {
              this.AccountSettings.custom_mappings = [{ Type: null, Value: null, Tax: null }]
              this.AccountSettings.custom_mappings = []
            }
            console.log(JSON.stringify(response.data.AccountSettings[0].custom_mappings))
          }
          this.totalCount = this.response.data.Subscribers.length
          this.lastRefreshed = moment()
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    saveAccountSetting (p) {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          self.$dialog.confirm('Are you sure you would like to save changes in the Account?')
            .then(function () {
              var obj = {
                AccountSettings: self.AccountSettings
              }

              axios.post('/api/mprove/AddAccountSettings', obj)
                .then(response => {
                  self.errMsg = 'Your changes has been saved'
                  self.dismissibleType = 'success'
                  self.showDismissibleAlert = true
                  self.boolLoading = false
                })
                .catch(error => {
                  if (error.response.status == 403) {
                    self.$router.push('/login')
                  }

                  self.boolLoading = false

                  self.errMsg = 'There was an error saving your changes : '
                  if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
                    self.errMsg = self.errMsg + error.response.statusText
                  } else {
                    self.errMsg = self.errMsg + error
                  }

                  self.showDismissibleAlert = true
                })
            })
            .catch(function () {
            })
        } else {
          self.errMsg = 'Please correct errors first'
          self.dismissibleType = 'danger'
          self.showDismissibleAlert = true

          setTimeout(function () {
            self.showDismissibleAlert = false
            self.errMsg = ''
          }, 8000)
        }
      })
    },
    disableSubscriber (Subscriber_Id, Disable) {
      var self = this
      self.$dialog.confirm('Are you sure you would like to disable this subscriber?')
        .then(function () {
          var obj = { Subscriber_Id: Subscriber_Id, Disable: Disable }
          axios.post('/api/mprove/settingsDisable', obj)
            .then(response => {
              self.fetchData()
              self.errMsg = 'Your changes has been saved'
              self.dismissibleType = 'success'
              self.showDismissibleAlert = true
              self.boolLoading = false
            })
            .catch(error => {
              if (error.response.status == 403) {
                self.$router.push('/login')
              }

              self.boolLoading = false

              self.errMsg = 'There was an error saving your changes : '
              if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
                self.errMsg = self.errMsg + error.response.statusText
              } else {
                self.errMsg = self.errMsg + error
              }

              self.showDismissibleAlert = true
            })
        })
        .catch(function () {
          // do nothing
        })
    },
    delCustomMapping (parentId) {
      var delList = []
      this.AccountSettings.custom_mappings.forEach(i => {
        if (i.Type === parentId) { delList.push(i.Type) }
      })
      delList.forEach(i => {
        var x = this.AccountSettings.custom_mappings.indexOf(this.AccountSettings.custom_mappings.filter(f => { return f.Type === i })[0])
        Vue.delete(this.AccountSettings.custom_mappings, x)
      })
    },

    IsDisabled: function (value) {
      return value === true
    },
    IsNotDisabled: function (value) {
      return value === false
      return value === false
    },
    addCustomMapping (cm) {
      var newCM = { Type: this.ddCustomMappingType, Value: '', Tax: 'None' }
      this.AccountSettings.custom_mappings.push(newCM)
    },
    addSubscriber (p) {
      this.$router.push('/mProveSettingsAdd/-1')
    },
    editSubscriber (Subscriber_Id) {
      this.$router.push('/mProveSettingsAdd/' + Subscriber_Id)
    }
  }
}
</script>

<style>
  body {
    background-color: #e4e5e6;
  }
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/mProveSettings.vue